import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { rdtInfringementPropType } from './rdt-infringement-prop-type'

export const rdtDriverInfringementPropType = PropTypes.shape({
    driverId: idPropType,
    infringements: PropTypes.arrayOf(rdtInfringementPropType)
})
